import { render, staticRenderFns } from "./save_search.vue?vue&type=template&id=2a62caba"
import script from "./save-search.js?vue&type=script&lang=js&external"
export * from "./save-search.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports